<template>
	<v-btn-toggle
		v-model="selectedSide"
		mandatory
		density="comfortable"
		color="primary"
	>
		<v-btn value="left" size="small">
			<v-icon icon="mdi-bed" size="small" :color="leftColor" class="mr-1" />
			{{ names.left }}
		</v-btn>
		<v-btn value="right" size="small">
			<v-icon icon="mdi-bed" size="small" :color="rightColor" class="mr-1" />
			{{ names.right }}
		</v-btn>
	</v-btn-toggle>
</template>

<script setup>
import { useSelectedSide } from "../composables/useSelectedSide.js";
import { useAllSideNames } from "../composables/useSideName.js";

var selectedSide = useSelectedSide();
var names = useAllSideNames();
var leftColor = "#42a5f5";
var rightColor = "#ec407a";
</script>
